import { render, staticRenderFns } from "./FormPageTemplate.vue?vue&type=template&id=fcf5561c&scoped=true&"
import script from "./FormPageTemplate.vue?vue&type=script&lang=js&"
export * from "./FormPageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./FormPageTemplate.vue?vue&type=style&index=0&id=fcf5561c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf5561c",
  null
  
)

export default component.exports